import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import Avatar from '@/components/avatar/Index.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import BaseSearchInput from '@/components/v2/BaseSearchInput';
import FormHeader from '@/components/v2/FormHeader.vue';
import MallOrders from '@/components/v2/ecommerce/MallOrderHistory';
import PageTitle from '@/components/v2/PageTitle.vue';
import Paginator from '@/components/v2/Paginator.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import TheOrderDetailsDialog from '@/components/v2/ecommerce/TheOrderDetailsDialog.vue';
import OrderDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/OrderDetailsMixin';
import TodaysOrderCount from '@/components/v2/ecommerce/TodaysOrderCount';
import { PER_PAGE } from '@/helpers/constants/app';
import LinkButton from '@/components/link_button/Index.vue';
import { enumValueNormalizer } from '@/helpers/enum_value_normalizer';
import OrderExport from '@/components/v2/ecommerce/OrderExport.vue';
let MallOrderHistory = class MallOrderHistory extends Mixins(OrderDetailsMixin, ViewportSizeMixin, RouterParamsAppMixin) {
    parseString(text) {
        return enumValueNormalizer(text);
    }
    get headers() {
        return [
            {
                text: 'REFERENCE ID',
                value: 'transactionNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PRODUCT NAME',
                value: 'productName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'BRANCH/STORE NAME',
                value: 'productName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOMER NAME',
                value: 'customerName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'AMOUNT',
                value: 'amount',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PAYMENT METHOD',
                value: 'customerName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PAYMENT STATUS',
                value: 'customerName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ORDER DATE',
                value: 'date',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ORDER STATUS',
                value: 'humanizedStatus',
                align: 'left',
                sortable: false,
            },
        ];
    }
    displayPaginator(total) {
        return total > PER_PAGE;
    }
    mounted() {
        const route = this.$router.currentRoute;
        const { txn } = route.query;
        if (txn) {
            const vm = this;
            vm.$refs.search.setValue(txn);
            vm.$refs.mallOrders.onSearch(txn);
        }
    }
};
MallOrderHistory = __decorate([
    Component({
        components: {
            Avatar,
            ActionButton,
            BaseAnalyticsBannerContent,
            BaseSearchInput,
            BaseOverlayLoader,
            FormHeader,
            MallOrders,
            PageTitle,
            Paginator,
            TheOrderDetailsDialog,
            TodaysOrderCount,
            LinkButton,
            OrderExport,
        },
    })
], MallOrderHistory);
export default MallOrderHistory;
